module.exports = __webpack_public_path__ + "fonts/summernote.c93a01ef.woff";